import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

interface IDonutChartProps {
	chartData: any;
	chartOptions: any;
}

interface IChartData {
	name: string;
	data: (number | null)[];
}

const DonutChart = (props: IDonutChartProps) => {
	const [chartData, setChartData] = useState<IChartData[]>([]);
	const [chartOptions, setChartOptions] = useState({});

	useEffect(() => {
		setChartData(props.chartData);
		setChartOptions(props.chartOptions);
	}, [props]);

	return (
		<ReactApexChart
			options={chartOptions}
			series={chartData}
			type='donut'
			width='100%'
			height='300px'
		/>
	);
};

export default DonutChart;
